<template>
  <div>
    <form @submit.prevent="submit" ref="addoficio">
      <div class="row">
        <form-input
          v-model="oficio.local"
          grid="4"
          label="Local"
          :required="true"
        />

        <form-calendar
          v-model="oficio.data_local"
          grid="4"
          label="Data"
          :required="true"
        />
        <form-calendar
          v-model="oficio.data_prazo_resposta"
          :required="true"
          grid="4"
          label="Prazo para a resposta"
        />
        <form-input
          v-model="oficio.nome_completo_detinatario"
          grid="6"
          label="Nome completo do destinatário"
          :required="true"
        />
        <form-input
          v-model="oficio.orgao_destinatario"
          grid="6"
          label="Nome do órgão destinatário"
        />

        <form-toggle
          grid="12"
          mt="0"
          v-model="campoExtra"
          label="Mais informações do destinatário"
        />
      </div>
      <div class="row" v-if="campoExtra">
        <form-input
          v-model="oficio.email_destinatario"
          grid="6"
          label="E-mail do destinatário"
          :required="true"
        />
        <form-input
          v-model="oficio.email_resposta"
          grid="6"
          label="E-mail de resposta"
        />
        <form-input
          v-model="oficio.telefone_destinatario"
          grid="6"
          label="Telefone do destinatário"
        />
        <form-input
          v-model="oficio.cargo_destinatario"
          grid="6"
          label="Cargo do destinatário"
        />
      </div>

      <form-endereco v-if="campoExtra" :item="oficio.endereco" />
      <search-tecnico :tecnicos.sync="oficio.tecnicos" />

      <div class="row">
        <form-input v-model="oficio.assunto" label="Assunto" :required="true" />
        <form-textarea-editor
          v-model="oficio.conteudo"
          label="Observação"
          :required="true"
        />
        <form-file
          @submit="submitFile"
          multiple
          btn-text="Iniciar"
          :progress="progressCompleted"
        />
      </div>
      <div class="row pt-4 px-0 d-flex justify-content-end">
        <form-toggle
          grid="4"
          class="d-flex justify-content-end"
          mt="0"
          v-model="oficio.privado"
          label="Sigilo?"
        />
        <div class="col-auto px-2 text-right">
          <a class="btn btn-default" @click="$emit('voltar')">
            <i class="mdi mdi-arrow-left" />
          </a>
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  export default {
    props: ["familia", "morph"],
    name: "Add",
    data() {
      return {
        oficio: {
          local: this.$store.state.settings.app_cidade,
          tecnicos: [],
          endereco: {
            numero_endereco: null,
            complemento_endereco: null,
            referencia_endereco: null,
            abrigo: false,
            localidade_id: null,
            logradouro_id: null,
            estado_id: null,
            cidade_id: null,
            situacao_rua: false,
            cidade: null,
            estado: null,
            localidade: null,
            logradouros: null,
            cep: null,
          },
        },
        files: [],
        progressCompleted: 0,
        localidades: [],
        localidade: {},
        logradouros: [],
        logradouro: {},
        localidade_bairro: "",
        logradouro: "",
        loadingLocalidade: false,
        loadingLogradouros: false,
        campoExtra: false,
      };
    },
    methods: {
      submitFile(files) {
        this.files = files;
      },
      submit() {
        // if (this.oficio.data_prazo_resposta) {
        //     this.oficio.data_prazo_resposta = moment(
        //         this.oficio.data_prazo_resposta,
        //         "YYYY-MM-DD"
        //     ).format("DD/MM/YYYY");
        // }
        // if (this.oficio.data_local) {
        //     this.oficio.data_local = moment(
        //         this.oficio.data_local,
        //         "YYYY-MM-DD"
        //     ).format("DD/MM/YYYY");
        // }
        if (this.familia) {
          this.oficio.familia_id = this.familia.id;
        }

        this.oficio.morph = this.morph;

        let formData = new FormData();
        if (this.files.length > 0 && this.files.length != undefined) {
          for (const i of Object.keys(this.files)) {
            formData.append("anexos[]", this.files[i]);
          }
        } else {
          formData.append("anexos", this.files);
        }

        for (var key in this.oficio) {
          if (key == "morph" && this.oficio.morph != undefined) {
            formData.append(key, this.oficio[key]);
            formData.append("morph_id", this.morph.id);
            formData.append("morph_type", this.morph.type);
          } else if (key == "endereco") {
            formData.append(key, JSON.stringify(this.oficio[key]));
          } else if (key == "tecnicos"){
            formData.append("tecnicos", JSON.stringify(this.oficio.tecnicos));
          } 
          else {
            formData.append(key, this.oficio[key]);
          }
        }

        let ladda = Ladda.create(document.querySelector(".btn-submit"));
        ladda.start();
        axios
          .post(`api/dashboard/oficios`, formData, {
            header: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (event) => {
              let progress = Math.round((event.loaded * 100) / event.total);
              this.progressCompleted = progress;
            },
          })
          .then((response) => {
            ladda.stop();
            this.$snack.success({
              button: false,
              text: response.data.data.message,
            });
            if (this.morph != undefined) {
              this.$emit("reload");
            } else {
              this.$router.push(
                `/dashboard/oficios/edit/${response.data.data.id}`
              );
            }
          })
          .finally(() => {
            this.progressCompleted = 0;
            this.files = [];
          });
      },
    },
  };
</script>
